import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import FopQuickMenu from '../components/FopQuickMenu';

import { openQuickMenu, closeQuickMenu } from 'apps/catalogue/actions/catalogue';
import { addToFavourites, removeFromFavourites } from 'apps/favourites/actions/favourites';
import { openShoppingListsModal } from 'apps/shoppingLists/actions/shoppingLists';

import { isUserLoggedIn } from 'apps/user/helpers';

export default withRouter(
  connect((state, ownProps) => {
    const { productsPageRoute } = ownProps;
    const routeString = productsPageRoute.toString();
    return {
      isLoggedIn: isUserLoggedIn(state.user),
      productsPage: state.catalogue.productsPagesByRoute[routeString],
      routeString,
    };
  }, {
    openQuickMenu,
    closeQuickMenu,
    addToFavourites,
    removeFromFavourites,
    openShoppingListsModal,
  })(FopQuickMenu)
);
